import { AUTH_OUTCOME, type AuthOutcome } from '@src/domains/customers/types/auth';

type Params = { logged: boolean };

export function decideAuthOutcome(state: Params): AuthOutcome {
  return state.logged ? { type: AUTH_OUTCOME.COMPLETED } : { type: AUTH_OUTCOME.NONE };
}
